import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Ears = ({ skinColours }) => {
  const primary = skinColours.base;
  const secondary = skinColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M289,396.8c-20.1-23-40.6-50.9-49.2-24c-20.1,62.7,44.7,115.9,58.1,89.8C311.4,436.5,289,396.8,289,396.8z"
        />
        <path
          fill={secondary}
          d="M284.2,401.1c-15.6-16.6-31.7-36.9-37-16.3c-12.3,48.1,37.3,86,46.1,65.7C302.1,430.3,284.2,401.1,284.2,401.1
		z"
        />
        <path
          fill={primary}
          d="M284.5,415.6c-9.6-13.4-19.2-29.6-25-15.3C246,433.7,278,465.7,286.3,452C294.6,438.3,284.5,415.6,284.5,415.6
		z"
        />
        <path
          fill={primary}
          d="M511.8,398.5c19.6-23,39.4-50.9,47.8-24c19.6,62.7-43.4,115.9-56.5,89.8C490,438.2,511.8,398.5,511.8,398.5z"
        />
        <path
          fill={secondary}
          d="M518.7,405.1c13.2-16.6,26.5-36.7,33-18c15.2,43.6-27.8,82.5-37.6,64.5C504.4,433.5,518.7,405.1,518.7,405.1z"
        />
        <path
          fill={primary}
          d="M519.7,421.1c7.5-11.3,14.8-24.8,20-13.3c12.1,26.9-13.1,54-20.3,43.1C512.2,440,519.7,421.1,519.7,421.1z"
        />
      </g>
    </>
  );
};

export default Ears;
